import { addressBook } from './shipping-address-book';
import { init as initStateButtonsHandler } from '../state-button-handler';

function initHomeselect () {
  $('.checkout__shipping__home-delivery input[type="radio"][name="delivery-type"]:checked').change();
}

function homeAddress () {
  addressBook();
};

function updateHomeShippingGroup (event) {
/* eslint-disable one-var */
  const postUrl = 'rest/model/atg/commerce/order/purchase/CreateHardgoodShippingGroupActor/addHardgoodShippingGroup',
    input   = event.currentTarget,
    params  = {
      selectedAddressId: input.dataset.selectedaddressid,
      shippingMethodOptionId: input.value,
      context: cube.$id('home-delivery').dataset.context
    };

  cube.ajax.form(postUrl, params).onSuccess((response) => {
    if(response && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].code) {
      cube.$('.dkt-checkout-primary-button').classList.add('error-shipping');
      cube.alert.error(window.Messages(response.responseTO.errors[0].code));
      initStateButtonsHandler();
    } else {
      cube.$('.dkt-checkout-primary-button').classList.remove('error-shipping');
      cube.event.send('checkout:refresh-order-summary');
    }
  }).call();
};

export { homeAddress, updateHomeShippingGroup, initHomeselect };



// WEBPACK FOOTER //
// ./src/modules-es5/checkout/shipping/home-delivery.js